export interface IApplicationState {

    showPromotionalScreen: boolean;
    freeRoundsRemaining: number;
    betLevel: number;
    totalWin: number;
    totalFreeRounds: number;
    totalValue: number;


}

const initialState: IApplicationState = {
    showPromotionalScreen: false,
    freeRoundsRemaining: 0,
    betLevel: 0,
    totalWin: 0,
    totalFreeRounds: 0,
    totalValue: 0,



};

export enum actionTypes {

    SHOW_PROMOTIONAL_FREE_ROUNDS = '@@promotionalFreeRounds/SHOW_PROMOTIONAL_FREE_ROUNDS',
    SET_FREE_ROUNDS_REMAINING = '@@promotionalFreeRounds/SET_FREE_ROUNDS_REMAINING',
    SET_BET_LEVEL = '@@promotionalFreeRounds/SET_BET_LEVEL',
    SET_TOTAL_WIN = '@@promotionalFreeRounds/SET_TOTAL_WIN',
    SET_TOTAL_FREE_ROUNDS = '@@promotionalFreeRounds/SET_TOTAL_FREE_ROUNDS',
    SET_TOTAL_VALUE = '@@promotionalFreeRounds/SET_TOTAL_VALUE',


}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { showPromotionalScreen, freeRoundsRemaining, betLevel, totalWin, totalFreeRounds, totalValue } = action;

    switch (action.type) {
        case actionTypes.SHOW_PROMOTIONAL_FREE_ROUNDS:
            return {
                ...state, showPromotionalScreen: showPromotionalScreen,
            };



        case actionTypes.SET_FREE_ROUNDS_REMAINING:
            return {
                ...state, freeRoundsRemaining: freeRoundsRemaining,
            };
        case actionTypes.SET_BET_LEVEL:
            return {
                ...state, betLevel: betLevel,
            };

        case actionTypes.SET_TOTAL_WIN:
            return {
                ...state, totalWin: totalWin,
            };
        case actionTypes.SET_TOTAL_FREE_ROUNDS:
            return {
                ...state, totalFreeRounds: totalFreeRounds,
            };

        case actionTypes.SET_TOTAL_VALUE:
            return {
                ...state, totalValue: totalValue,
            };
        default:
            return state;
    }
}

export const actions = {
    promotionalScreenShow: (showPromotionalScreen: boolean): any => ({
        type: actionTypes.SHOW_PROMOTIONAL_FREE_ROUNDS,
        showPromotionalScreen
    }),


    remainingFreeRounds: (freeRoundsRemaining: number): any => ({
        type: actionTypes.SET_FREE_ROUNDS_REMAINING,
        freeRoundsRemaining
    }),

    levelOfBet: (betLevel: number): any => ({
        type: actionTypes.SET_BET_LEVEL,
        betLevel
    }),

    totalWinAmount: (totalWin: number): any => ({
        type: actionTypes.SET_TOTAL_WIN,
        totalWin
    }),

    setTotalFreeRounds: (totalFreeRounds: number): any => ({
        type: actionTypes.SET_TOTAL_FREE_ROUNDS,
        totalFreeRounds
    }),
    setTotalValue: (totalValue: number): any => ({
        type: actionTypes.SET_TOTAL_VALUE,
        totalValue
    }),
};


